import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import PrivacyBanner from "@/components/PrivacyBanner";

import Landing from "@/pages/Landing";
import Wizard from "@/pages/Wizard";
import PremiumPage from "@/pages/PremiumPage";
import CaseDashboard from "@/pages/CaseDashboard";
import Custody from "@/pages/Custody";
import SampleProtocol from "@/pages/SampleProtocol";
import VerbaleAccesso from "@/pages/VerbaleAccesso";
import AuthCallback from "@/pages/AuthCallback";
import AdminOrders from "@/pages/AdminOrders";
import AdminLeads from "@/pages/AdminLeads";
import AdminCrm from "@/pages/AdminCrm";
import AdminCaseEditor from "@/pages/AdminCaseEditor";
import FascicoloSuccess from "@/pages/FascicoloSuccess";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors closeButton />
          <PrivacyBanner />
          <Routes>
            {/* PUBLIC */}
            <Route path="/" element={<Landing />} />
            <Route path="/wizard" element={<Wizard />} />
            <Route path="/case/:id" element={<CaseDashboard />} />
            <Route path="/case/:id/premium" element={<PremiumPage />} />
            <Route path="/fascicolo/success" element={<FascicoloSuccess />} />

            {/* ADMIN LOGIN CALLBACK */}
            <Route path="/auth/callback" element={<AuthCallback />} />

            {/* ADMIN-ONLY TOOLS (protected server-side; UI hides them if !isAdmin) */}
            <Route path="/admin/leads" element={<AdminLeads />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
            <Route path="/admin/crm" element={<AdminCrm />} />
            <Route path="/admin/case/:id/edit" element={<AdminCaseEditor />} />
            <Route path="/verbale-accesso" element={<VerbaleAccesso />} />
            <Route path="/custody" element={<Custody />} />
            <Route path="/sample-protocol" element={<SampleProtocol />} />

            {/* Legacy paths → home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
